// SecurityAcl CLASS
export class SecurityAcl {
	constructor( onlyData ) {
		this.depend = onlyData.depend;
		this.inPath = onlyData.inPath;
		this.target = onlyData.target;
		this.granted = onlyData.granted;
		this.acl = onlyData.acl;
	}

	get level() {
		return this.target.length;
	}

	Match(targetToCheck) {
		if (this.target.length <= targetToCheck.length) {
			for (let i = 0; i < this.target.length; i++)
			{
				if (this.target[i] != "*" && targetToCheck[i] != "*" && this.target[i] != targetToCheck[i])
					return null;
			}
			return this;
        }
		else {
			return null;
		}
	}
}

// AuthCheckAcl
export class AuthCheckAcl {
	constructor() {
		this.target = null;
		this.acl = null;
		//
		if (arguments.length == 1) {
			let tks = arguments[0].split(":");
			if (tks.length == 2) {
				this.target = tks[0];
				this.acl = tks[1];
			}
		}
		else if (arguments.length == 2) {
			this.target = arguments[0];
			this.acl = arguments[1];
        }
	}
}

// SecurityAclContext CLASS
export class SecurityAclContext {
	constructor( bRefrehOnChange = false ) {
		this.init( null );
		// se cambia la sessione lo refresho
		if (bRefrehOnChange)
			TheDisp.addEventListener(TheDisp.EV_USERSESSION_UPDATE, this.init.bind(this),false);
	}

	init(ev) {
		//this.acls = []; // of SecurityAcl
		this.aclsList = []; // of array of SecurityAcl
		this.Roles = []; // ROLES
		this.IsAuthenticated = false;
		//
		let _aclContext = null;
		//
		try {
			this.IsAuthenticated = TheApp.CurrentContext.IsAuthenticated;
			this.Roles = TheApp.CurrentContext.userSession.authToken.permissions;
			_aclContext = TheApp.CurrentContext.userSession.aclContext;
		} catch (ex) {
			_aclContext = null;
		}
		// se ho acl context
		/*
		if (_aclContext && _aclContext.acls) {
			for (let _ac of _aclContext.acls) {
				this.acls.push(new SecurityAcl(_ac));
			}
		}
		*/
		if (_aclContext && _aclContext.aclsList) {
			for (let _acls of _aclContext.aclsList) {
				let acls = [];
				this.aclsList.push(acls);
				for (let _ac of _acls) {
					acls.push(new SecurityAcl(_ac));
				}
			} 
		}


		/*
		let xxx = new AuthCheckAcl("AA:READ")
		let yyy = new AuthCheckAcl("BB","READ")
		*/
		//debugger;
		//
		// console.log(this.Roles);
	}

	GetAllGrantedAcl(_target)
	{
		//debugger;
		let ret = [];
		//
		if (this.aclsList == null || this.aclsList.length < 1)
			return ret;
		//
		let targetToCheck = (_target != null ? _target : "").replace(/^\|+|\|+$/g, '').split("|");
		if (targetToCheck.length == 0)
			return ret;
		// scorro tutte le acl
		for (let acls of this.aclsList) {
			// lista temporanea
			let tmp = {};
			// scorro la lista delle mie acl sono ordinale per livello
			for (let a of acls) {
				let aFound = a.Match(targetToCheck);
				if (aFound != null) {
					if (!tmp.hasOwnProperty(a.acl))
						tmp[a.acl] = { found: aFound, granted: aFound.granted };
					else
						tmp[a.acl].granted = tmp[a.acl].granted && aFound.granted;
					// basic
					if (tmp[a.acl].found.inPath && tmp[a.acl].found.level != 1)
						tmp[a.acl].granted = false;
				}
			}
			// a questo punto le ripasso tutte per le basic
			for (let k in tmp) {
				let e = tmp[k];
				if (e.found.depend != null) {
					if (!tmp.hasOwnProperty(e.found.depend) || !tmp[e.found.depend].granted)
						e.granted = false;
				}
			}
			for (let k in tmp) {
				let e = tmp[k];
				if (e.granted)
					ret.push(e.found.acl);
			}
		}
		//
		return ret;
    }

	HasGrantedAcl(/*AuthCheckAcl*/ checkAcl) {
		let dd = this.GetAllGrantedAcl(checkAcl.target);
		return dd.find((x) => x == checkAcl.acl) != undefined;
	}

}


// *******************************************************************************
// FUNZIONI PRINCIPALI // o ruoli // tutti devono avere USR  posso averne multipli
// ho solo un gruppo invece che ha i security roles
// *******************************************************************************
SecurityAcl.ROLE_USR			 = "USR";
SecurityAcl.ROLE_SYSADM			 = "SYSADM";
SecurityAcl.ROLE_RESTAURO		 = "RESTAURO";
SecurityAcl.ROLE_AMMINISTRAZIONE = "AMMINISTRAZIONE";
SecurityAcl.ROLE_CURATORE		 = "CURATORE";

// *******************************************************************************
// SEZIONI PRINCIPALI
// *******************************************************************************
SecurityAcl.SEZ_LOOKUP = "LOOKUP";
SecurityAcl.SEZ_LIBRARY = "LIBRARY";

// *******************************************************************************
// ACL BASE
// *******************************************************************************
SecurityAcl.ACL_READ			= "READ";
SecurityAcl.ACL_CREATE			= "CREATE";
SecurityAcl.ACL_DELETE			= "DELETE";
SecurityAcl.ACL_UPDATE			= "UPDATE";
SecurityAcl.ACL_APPROVED		= "APPROVED";
SecurityAcl.ACL_FULLUPDATE		= "FULLUPDATE";
SecurityAcl.ACL_PLUS			= "PLUS";
SecurityAcl.ACL_EXPORT			= "EXPORT";

